export const productCard = {
	infoProduct: `Producto "{{nameProduct}}" omitido`,
	restoreproduct: "Haga clic aquí para restaurar.",
	code: "SKU:",
	quantities: "Cant:",
	unit: "Un:",
	unitPrice: "Pagado por unidad:",
	unitPriceTooltip: "Valor por unidad en factura fiscal",
	equivalentProduct: "Producto equivalente",
	productNotFound: "Producto no encontrado",
	wishToCreate: "¿Desea crearlo?",
	equivalentUnit: "1 {{product}} equivale a",
	costPricePerUnit: "Costo unitario",
	costPricePerUnitTooltip: "Valor por unidad en el sistema Zig",
	costTypeOptions: {
		total: "en total",
		unit: "por unidad",
		milliliter: "por mililitro",
		gram: "por gramo",
		kilogram: "por kilogramo",
		liter: "por litro",
	},
	chartAccount: "Plan de Cuentas",
	chartAccountPlaceholder: "Seleccione un plan de cuentas",
};
